<!--
  --
  -- 本人確認 メールアドレス 入力フォーム
  --
  -->
<template>
  <c-form card-style
    v-model="valid"
    @submit="onSubmit"
  >
    <!-- Title -->
    <v-card-title>
      <slot name="title"/>
    </v-card-title>

    <!-- Contents -->
    <v-card-text>
      <slot/>

      <v-text-field
        label="メールアドレス"
        prepend-icon="email"
        type="text"
        v-model="form.email"
        :rules="[rule.required('メールアドレス'), rule.email]"
        @input="errors = []"
      />
    </v-card-text>

    <c-card-errors :errors="errors"/>

    <!-- Actions -->
    <v-card-actions>
      <v-spacer/>

      <v-btn
        color="primary" type="submit"
        :loading="running"
        :disabled="!valid || running"
      >
        <slot name="submit-text"/>
      </v-btn>
    </v-card-actions>
  </c-form>
</template>

<script>
import CForm from './CForm'
import CCardErrors from './CCardErrors'

export default {
  name: 'CIdentificationEmailForm',
  components: {
    CForm,
    CCardErrors
  },
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    // フォームのバリデーション状態
    valid: true,

    // フォームのエラーメッセージ
    errors: [],

    // 処理中
    running: false
  }),
  methods: {
    onSubmit () {
      // エラー表示を消す
      this.errors = []

      // メール送信を行う
      this.running = true
      this.$emit('send', this.form.email, (errors) => {
        this.running = false
        this.errors = errors || []
      })
    }
  }
}
</script>
